export const TAPPING_DAMAGE_REQUEST = "TAPPING_DAMAGE_REQUEST";
export const TAPPING_DAMAGE_SUCCESS = "TAPPING_DAMAGE_SUCCESS";
export const TAPPING_DAMAGE_FAILED = "TAPPING_DAMAGE_FAILED";